import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './services/auth/auth-guard.service';

const appRoutes: Routes = [

    {
        path: 'widgets',
        loadChildren: './widgets/widgets.module#WidgetsModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'mydetails',
        loadChildren: './mydetails/mydetails.module#MyDetailsModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'activity',
        loadChildren: './activity/activity.module#ActivityModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'paymenthistory',
        loadChildren: './paymentHistory/paymentHistory.module#PaymentHistoryModule',
        canActivate: [AuthGuard]
    },
    {
        path: '**',
        redirectTo: ''
    }

];

export const appRoutingProviders: any[] = [
    AuthGuard
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./app/app.routing.ts